"use client";

import { motion } from "framer-motion";
import { useRouter, usePathname } from "next/navigation";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Telescope, Hammer, TrendingUp } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const ModeToggle = ({
  mode,
}: {
  mode?: "chat" | "strategy";
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const { user } = useAuth();

  const currentMode = pathname.startsWith("/strategy") || pathname.startsWith("/demo-strategy")
    ? "strategy"
    : "chat";

  const handleTabChange = (value: string) => {
    if (value === "strategy") {
      router.push(user ? "/strategy" : "/demo-strategy");
    } else {
      router.push(user ? "/" : "/demo");
    }
  };

  return <div className="mb-6 mt-4" />;
};
